"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function classNameForTextColor(textColor, onColor) {
    return constants_1.BASE_CLASS_NAME + "--text-" + textColor + "-on-" + onColor;
}
exports.classNameForTextColor = classNameForTextColor;
function classNameForColor(color) {
    return constants_1.BASE_CLASS_NAME + "--" + color;
}
exports.classNameForColor = classNameForColor;
function classNameForBackground(backgroundColor) {
    return constants_1.BASE_CLASS_NAME + "--" + backgroundColor + "-bg";
}
exports.classNameForBackground = classNameForBackground;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/theme/lib/utils.js
// module id = ./node_modules/@react-mdc/theme/lib/utils.js
// module chunks = 2